export default function (state = {}, action) {
    switch (action.type) {
        case "USER_DATA":
            return action.payload;
            break;
        default:
            return state;
    }
}
